<script>
    import Nav from './Nav.svelte';
    import Div from './Div.svelte';
    import { lge, dvn } from './store.js';
    import { onMount } from 'svelte';
       
    let lghds = ['Club 55','Mid-Week','Week-End'];
    let dvhds = ['Premier','First','Second','Third','Fourth'];
    let data = [];
    let lgehdr = lghds[$lge/5];
    let divhdr = dvhds[$dvn];

    async function getData() {
         lgehdr = lghds[$lge/5];
         if ($lge == 10 && $dvn > 2 ) {
             $dvn=2;
         }
         if ($lge == 5 && $dvn > 3 ) {
             $dvn=3;
         }
         divhdr = dvhds[$dvn];
         const res = await fetch(`https://www.bowls-league.com/mobile/league${$lge + $dvn}.json`); 
         data = await res.json();
        }

    onMount (() => {getData()});
</script>

<style>
.container {
    display:grid;
    grid-template-columns:40% 7.5% 7.5% 7.5% 12.5% 12.5% 12.5%;
    grid-row-gap: 4px;
    }

.hdr {
    background:tan
}

.item {
    border:1px solid rgba(0, 0, 0, 0.8);
    padding:2px;
    text-align:left
}

.itm {
    border:1px solid #000000cc;
    padding:2px;
    text-align:right
}

h2,h3 {
    text-align: center;
    margin: 0 0 0 0;
    line-height: 1.5;
    padding: 2px;
    background-color: mistyrose
}
</style>

  <header class="header">
    <Nav on:LgeUpd={getData}/>
  </header>
  <section >
  <h2 >Peterborough Bowls League</h2>
  <h3>{lgehdr} {divhdr} Division</h3>
   <div class="container">
       <div class="item hdr">&nbsp;Teams</div><div class="itm hdr">P&nbsp;</div>
       <div class="itm hdr">W&nbsp;</div><div class="itm hdr">D&nbsp;</div>
       <div class="itm hdr">Pts&nbsp;&nbsp;</div>
       <div class="itm hdr">Shts&nbsp;</div><div class="itm hdr">Agns&nbsp;</div>
       {#each data as team }
          <div class="item"><a href="#/fix/{team.i}">{team.n}</a></div>
          {#each team.d as num}
            <div class="itm">{num}</div>
          {/each}
       {/each}
   </div>
   </section>
   
   <footer class="header">
     <Div on:LgeUpd={getData}/>
   </footer>